import { Calendar, Trophy } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { formatINR } from '@/lib/format';

export const MilestoneCard = ({ cardName, bank, milestone }) => {
  const pct = Math.min(100, Math.round((milestone.current / milestone.target) * 100));
  const remaining = Math.max(0, milestone.target - milestone.current);

  return (
    <Card data-testid="milestone-progress-card" className="p-5">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-xs text-muted-foreground">{bank} · {cardName}</div>
          <div className="mt-0.5 font-display text-base font-semibold tracking-tight truncate">{milestone.name}</div>
          <div className="mt-1 flex items-center gap-1.5 text-xs text-muted-foreground">
            <Trophy className="h-3.5 w-3.5 text-accent" />
            <span>Reward: {milestone.reward}</span>
          </div>
        </div>
        <Badge variant="secondary" className="font-mono-num">{pct}%</Badge>
      </div>

      <div className="mt-4">
        <Progress value={pct} className="h-1.5" />
        <div className="mt-2 flex items-center justify-between text-xs">
          <span className="text-muted-foreground">
            <span className="font-mono-num text-foreground">{formatINR(milestone.current, { compact: true })}</span> / {formatINR(milestone.target, { compact: true })}
          </span>
          <span className="font-mono-num text-foreground">{formatINR(remaining, { compact: true })} to go</span>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Calendar className="h-3.5 w-3.5" />
          <span>Anniversary year</span>
        </div>
        <Button
          data-testid="milestone-set-reminder-button"
          variant="ghost"
          size="sm"
          className="text-primary hover:text-primary"
        >
          Set reminder
        </Button>
      </div>
    </Card>
  );
};
